module.exports = "https://static.im-cdn.com/mjc/storefront/Ikkat/static/media/toastBag.a6f9c8f9.svg";